<script lang="ts">
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';
  import { progressManager } from '$src/stores/posts.store';
  import type { Writable } from 'svelte/store';

  export let image: string = '';
  export let gi: number;
  let progressTween: Writable<number>;

  const refreshTween = async () => {
    let key = typeof image === 'string' ? image : URL.createObjectURL(image);
    key = key.trim();
    progressTween = await progressManager.getProgressStore(key, gi);
  };

  $: if (image) {
    refreshTween();
  }
  onMount(() => {
    refreshTween();
  });
</script>

{#key image}
  {#if progressTween && $progressTween > 0 && $progressTween != 100}
    <div class="w-full bg-color-gray-line rounded-full h-2" transition:slide|global>
      <div class="bg-brand-green-50 h-2 rounded-full" style="width: {$progressTween}%" />
    </div>
  {/if}

  {#if $progressTween == -1}
    <div class="w-full bg-color-gray-line rounded-full h-2" transition:slide|global>
      <div
        class="bg-red-300 h-4 rounded-full flex flex-row px-3 text-center text-stone-800"
        style="width: {$progressTween}%"
      >
        <small class=" font-semibold text-md whitespace-nowrap"> File Too large </small>
      </div>
    </div>
  {/if}
{/key}
